// extracted by mini-css-extract-plugin
module.exports = {"forminput":"ExamDetail_forminput_fkm9G"};